import { getCountryName } from '@ovComponents/resources';
import { Typography } from 'hephaestus/web';
import { useLocalization } from '../../../hooks/useLocalization';

export const CountryName = ({ code }: { code: string }) => {
  const { language } = useLocalization();
  return (
    <Typography variant='bodyLarge'>
      {getCountryName(code, language) || code}
    </Typography>
  );
};
